module.exports = __webpack_public_path__ + "static/media/verify.cce19fe1.svg";